<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-medium"
            @close="close"
			:hideFooter="true"
            v-if="isShowAssign">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Assign ') }}{{titleAssignModal}}{{ $t(' to User') }}</h5>
            </template>
            <template slot="body">
				<div class="form-group rundown-collab mt-2 mb-2">
					<label>S</label><label class="lowercase">elected {{titleAssignModal}} will only visible to assigned user</label>
					<div>
						<multiselect class="rundown-collab-input" v-model="userIds" tag-placeholder="Add User"
						placeholder="Search or add a user" label="name" track-by="id"
						:options="filteredUser"  :multiple="true" :searchable="true" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						<span slot="noResult">Oops! No Users found.</span></multiselect>
					</div>
				</div>
				<div class="text-right">
					<label class="text-primary pointer" @click="openModalListAssignedUser">List of Assigned Users</label>
				</div>
				<button
					:disabled="!userIds || userIds && userIds.length === 0"
					class="btn btn-primary"
					@click="assignUsers">
					{{ $t('Assign ') }}{{titleAssignModal}}
				</button>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<!-- modal list user -->
		<modal
            size="large"
            @close="isOpenModalListAssignedUser = false"
			:hideFooter="true"
            v-if="isOpenModalListAssignedUser">
            <template slot="header">
                <h5 class="mb-0">{{ $t('List Users has assigned ') }}{{titleAssignModal}}</h5>
            </template>
            <template slot="body">
				<div class="assigned-user-modal">
					<!-- Table Menu -->
					<!-- <div class="table-menu flex-center">
						<div>
							<input
								type="text"
								class="form-control"
								:placeholder="$t('Search')"
								@input="onKeywordChange"
								v-model="keyword"
							/>
						</div>
					</div> -->
					<!-- Main Table -->
					<table class="table table-striped mb-4">
						<thead>
							<tr>
								<th >{{ $t('No') }}</th>
								<th width="40%">{{ $t('Name') }}</th>
								<th width="40%">{{ $t('Email') }}</th>
								<th width="10%"></th>
							</tr>
						</thead>
						<div class="p-5 text-center absolute" v-if="isGetAssignUsers">
							<div class="is-loading large"></div>
						</div>
						<tbody>
							<tr
								v-for="(item, index) in assignedUser"
								:key="item.id">
								<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
								<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ (item.name) }}</td>
								<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ (item.email) }}</td>
								<td class="btn-action-table text-right" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
									<button v-if="hover && hoverItem === item.id"
										class="btn btn-danger btn-icon mr-3"
										v-tooltip="$t('Unassigned to this user')"
										@click="confirmRemoveItem(item)">
										<i class="material-icons md-18">delete</i>
									</button>
								</td>
							</tr>
						</tbody>
					<div class="text-center absolute disabled mt-4" v-if="assignedUser.length === 0 && !isGetAssignUsers">{{$t('No Users available')}}</div>
					</table>
				</div>
				<!-- Table Pagination -->
				<pagination
					v-if="!isGetAssignUsers"
					:total-pages="totalPages"
					:current-page="page"
					:last-page="lastPage"
					@select="onPageSelected">
				</pagination>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<!-- Delete Confirmation -->
		<modal
			size="small"
			@close="isConfirmRemoveVisible = false"
			v-if="isConfirmRemoveVisible && selected">
			<template slot="header">
				{{ $t('Remove User') }}
			</template>
			<template slot="body">
				{{ $t('Are you sure want to delte') }} {{ showModalName(selected.name) }}?
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button
						class="btn btn-primary"
						:class="{ 'is-loading': isUnAssignUsers }"
						@click="unassignedUser(selected)">
						{{ $t('Remove') }}
					</button>
					<button
						class="btn btn-default"
						@click="isConfirmRemoveVisible = false">
						{{ $t('Cancel') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import Pagination from '@/components/Pagination.vue';
import usersApi from '@/api/user';
import mediaAssignApi from '@/api/media-assign';
import templateAssignApi from '@/api/template-assign';


import {
	getAxiosErrorMessage,
	delay,
	elpisisString,
} from '@/lib/helper';

export default {
	name: 'ModalAssignUser',
	components: {
		Modal,
		Multiselect,
		Pagination,
	},
	props: {
		data: {
			type: Object,
		},
		titleAssignModal: {},
		isShowAssign: {
			type: Boolean,
			default: false,
		},
	},
	mounted() {
	},
	data: () => ({
		page: 1,
		limit: 10,
		lastPage: 1,
		totalItems: 1,
		orderBy: 'created_at',
		sortBy: 'desc',
		keyword: '',
		users: [],
		userIds: [],
		assignedUser: [],
		isFetchingUsers: false,
		isOpenModalListAssignedUser: false,
		isGetAssignUsers: false,
		hover: false,
		hoverItem: null,
		isConfirmRemoveVisible: false,
		selected: '',
		isUnAssignUsers: false,
	}),
	methods: {
		close() {
			this.$emit('close');
		},
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		fetchUsers() {
			this.isFetchingUsers = true;
			const callback = (response) => {
				const items = response.data;
				this.users = items;
				this.isFetchingUsers = false;
				if (this.data) {
					const index = this.users.findIndex(({ id }) => id === this.data.user_id);
					this.userIds = this.users[index];
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetchingUsers = false;
			};
			const params = {
				page: 1,
				limit: 9999,
			};
			usersApi.getUsers(params, callback, errorCallback);
		},
		openModalListAssignedUser() {
			this.getAssignUsers(true);
			this.isOpenModalListAssignedUser = true;
		},
		assignUsers() {
			this.isAssignUsers = true;
			const callback = (response) => {
				this.isAssignUsers = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Users',
					text: response.message,
				});
				this.isAssignUsers = false;
				this.userIds = [];
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isAssignUsers = false;
				this.userIds = [];
			};
			const resultUserIds = [];
			for (let index = 0; index < this.userIds.length; index++) {
				const id = this.userIds[index].id;
				resultUserIds.push(id);
			}
			if (this.titleAssignModal === 'media') {
				const params = {
					user_ids: JSON.stringify(resultUserIds),
					media_id: this.data.id,
				};
				mediaAssignApi.create(params, callback, errorCallback);
			} else {
				const params = {
					user_ids: JSON.stringify(resultUserIds),
					template_id: this.data.id,
				};
				templateAssignApi.create(params, callback, errorCallback);
			}
		},
		getAssignUsers(reset = false, page) {
			this.isGetAssignUsers = true;
			if (reset) {
				this.page = 1;
				this.assignedUser = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				this.isGetAssignUsers = false;
				if (items.length < this.limit) this.isAll = true;
				this.assignedUser = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isGetAssignUsers = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isGetAssignUsers = false;
			};
			if (this.titleAssignModal === 'media') {
				mediaAssignApi.getList(params, callback, errorCallback);
			} else {
				templateAssignApi.getList(params, callback, errorCallback);
			}
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		unassignedUser(item) {
			this.isUnAssignUsers = true;
			const callback = (response) => {
				const index = this.assignedUser.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.assignedUser.splice(index, 1);
				}
				this.isUnAssignUsers = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Users',
					text: response.message,
				});
				this.isUnAssignUsers = false;
				this.isConfirmRemoveVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isUnAssignUsers = false;
				this.isConfirmRemoveVisible = false;
			};
			if (this.titleAssignModal === 'media') {
				mediaAssignApi.delete(item.id, callback, errorCallback);
			} else {
				templateAssignApi.delete(item.id, callback, errorCallback);
			}
		},
		onPageSelected(page) {
			this.getAssignUsers(true, page);
		},
		onKeywordChange() {
			delay(() => {
				this.getAssignUsers(true);
			}, 500);
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
		showModalName(str) {
			return elpisisString(str);
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
		}),
		filteredUser() {
			const filter = item => (!item.roles.includes('super_admin'));
			return this.users.filter(filter);
		},
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				keyword: this.keyword,
			};
			if (this.titleAssignModal === 'media') {
				params.media_id = this.data.id;
			} else {
				params.template_id = this.data.id;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetchUsers();
	},
};
</script>

<style>
.assigned-user-modal{
	min-height: 500px!important;
}
</style>
